import React, { Component } from "react";
import {Modal} from "react-bootstrap";


class ModalDialog extends Component {

    render() {

        return (
            <div>
                <Modal show={this.props.show} onHide={() => this.props.onHide({ msg: 'lukk' })} backdrop="static" >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.props.body}</Modal.Body>
                    <Modal.Footer>
                        <button className="buttonBlue float-md-right" type="button" onClick={() => this.props.onClick({ msg: 'nei' })}>Nei</button>
                        <button className="buttonBlue float-md-right" type="button" onClick={() => this.props.onClick({ msg: 'ja', data: this.props.data })}>Ja</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    };
}

export default ModalDialog;